export default __webpack_public_path__ + "static/media/check.9b64b2a6.svg";